import { UnassignedTripSearch } from './UnassignedTripSearch';
import { UnassignedTripsFilters } from './UnassignedTripsFilterMenu/UnassignedTripsFilters';
import { UnassignedTripsSortMenu } from './UnassignedTripsSortMenu/UnassignedTripsSortMenu';

export function UnassignedTripsHeader() {
  return (
    <div className={`relative flex flex-col gap-y-3 bg-white text-left`}>
      <div className="flex w-full items-start justify-between">
        <div className="flex flex-row gap-2">
          <UnassignedTripsFilters />
          <UnassignedTripsSortMenu />
        </div>
        <div className="min-w-[225px]">
          <UnassignedTripSearch />
        </div>
      </div>
    </div>
  );
}
